import * as signalR from '@microsoft/signalr'
import { getJwt } from '../utils/authentication'
import { CustomReconnectPolicy } from './lib/customReconnectPolicy'
import { updateAuthTokens } from '../store/actions/authentication'

export const createSignalRConnection = () =>
    new signalR.HubConnectionBuilder()
        .withUrl('/signalr', {
            accessTokenFactory: () => {
                setTimeout(() => {
                    updateAuthTokens()
                        .then(
                            (tokens) =>
                                tokens?.access_token &&
                                console.info('Tokens updated')
                        )
                        .catch((e) => console.error(e))
                }, 1000)
                return getJwt() ?? ''
            },
            withCredentials: true,
            transport:
                process.env.NODE_ENV === 'production'
                    ? undefined
                    : signalR.HttpTransportType.WebSockets,
        })
        .configureLogging(signalR.LogLevel.Information)
        .withAutomaticReconnect(new CustomReconnectPolicy())
        .build()